export enum UIActions {
  CreateShipment = 'CreateShipment',
  ExportShipment = 'ExportShipment',
  UpdateShipment = 'UpdateShipment',
  CreateConfig = 'CreateConfig',

  CreateDevice = 'CreateDevice',
  ImportDevice = 'ImportDevice',
  ExportDevice = 'ExportDevice',
  UpdateDevice = 'UpdateDevice',
  ViewUploadHistory = 'ViewUploadHistory',
  SwapIMEI = 'SwapIMEI',
  SendBackToAgent = 'SendBackToAgent',

  CreateWorkTool = 'CreateWorkTool',
  ImportWorkTool = 'ImportWorkTool',
  ExportWorkTool = 'ExportWorkTool',
  UpdateWorkTool = 'UpdateWorkTool',
  LockWorkTool = 'LockWorkTool',
  UnlockWorkTool = 'UnlockWorkTool',

  CreateCategory = 'CreateCategory',
  ImportCategory = 'ImportCategory',
  ExportCategory = 'ExportCategory',
  UpdateCategory = 'UpdateCategory',

  CreateProduct = 'CreateProduct',
  ImportProduct = 'ImportProduct',
  ExportProduct = 'ExportProduct',
  UpdateProduct = 'UpdateProduct',

  ApproveAgentRequest = 'ApproveAgentRequest',
  ExportAgentRequest = 'ExportAgentRequest',
  UpdateAgentRequest = 'UpdateAgentRequest',
  DeleteAgentRequest = 'DeleteAgentRequest',

  ApproveUserRequest = 'ApproveUserRequest',
  ExportUserRequest = 'ExportUserRequest',
  LockDevice = 'LockDevice',
  UnlockDevice = 'UnlockDevice',
  RecallDevice = 'RecallDevice',
  CreateUser = 'CreateUser',
  ImportUser = 'ImportUser',
  ExportUser = 'ExportUser',
  UpdateUser = 'UpdateUser',
  DeleteUser = 'DeleteUser',

  CreateBusinessLocation = 'CreateBusinessLocation',
  ImportBusinessLocation = 'ImportBusinessLocation',
  ExportBusinessLocation = 'ExportBusinessLocation',
  UpdateBusinessLocation = 'UpdateBusinessLocation',
  DeleteBusinessLocation = 'DeleteBusinessLocation',

  ExportReport = 'ExportReport',

  CreateRole = 'CreateRole',
  EditRole = 'EditRole',
  CreateStakeholder = 'CreateStakeholder',
  ImportStakeholder = 'ImportStakeholder',
  ExportStakeholder = 'ExportStakeholder',
  UpdateStakeholder = 'UpdateStakeholder',
  DeleteStakeholder = 'DeleteStakeholder',

  CreateEscalation = 'CreateEscalation',
  ImportEscalation = 'ImportEscalation',
  ExportEscalation = 'ExportEscalation',
  UpdateEscalation = 'UpdateEscalation',
  DeleteEscalation = 'DeleteEscalation',

  DeviceRepairAction = 'DeviceRepairAction',
  ExportRepairRequest = 'ExportRepairRequest',
  ConfirmRepair = 'ConfirmRepair',

  ExportAgent = 'ExportAgent',
  LoadWithLocation = 'LoadWithLocation',
  WithdrawDevice = 'WithdrawDevice',
  SendForRepair = 'SendForRepair',
  ReassignAgents = 'ReassignAgents',
  UpdateAgents = 'UpdateAgents',

  ExportActivityLog = 'ExportActivityLog',

  ApproveAgentReassignment = 'ApproveAgentReassignment',
  DeleteAgentReassignment = 'DeleteAgentReassignment',

  GenerateToken = 'GenerateToken',

  ViewAnalytics = 'ViewAnalytics',
  // AnalyticsSetup = 'AnalyticsSetup',

  ApproveWorkToolRequest = 'ApproveWorkToolRequest',
  ExportWorkToolRequest = 'ExportWorkToolRequest',

  ExportWorkToolHolders = 'ExportWorkToolHolders',
  WithdrawWorkTool = 'WithdrawWorkTool',
  ReassignWorkTool = 'ReassignWorkTool',

  ApproveWorkToolReassignment = 'ApproveWorkToolReassignment',
  DeleteWorkToolReassignment = 'DeleteWorkToolReassignment',

  CreateOfficeLocation = 'CreateOfficeLocation',
  ImportOfficeLocation = 'ImportOfficeLocation',
  ExportOfficeLocation = 'ExportOfficeLocation',
  UpdateOfficeLocation = 'UpdateOfficeLocation',
  DeleteOfficeLocation = 'DeleteOfficeLocation',

  CreateTerritory = 'CreateTerritory',
  ImportTerritory = 'ImportTerritory',
  ExportTerritory = 'ExportTerritory',
  UpdateTerritory = 'UpdateTerritory',

  ExportRDUsers = 'ExportRDUsers',
}
